import { memo, useMemo } from 'react';
import { Flex, Modal, Typography } from 'antd';
import { FormikProps } from 'formik';
import { MButton, MInput, MSelect } from '@Components/Base';

import { getSIMCapValueDictSelector } from '@Store/selectors/dictionarySelector';
import { useAppSelector } from '@Hooks/index';
import { transformDictToOptionsNum } from '@Utils/transformToOptions';

import { initFormikValuesType } from './types';

import styles from './sim-card-notification.module.css';

interface SimCardNotificationProps {
  title: string;
  textSuccessBtn: string;
  isModalOpen: boolean;
  formik: FormikProps<initFormikValuesType>;
  simCardRequest: 'Input' | 'Dropdown' | '';
  handleSuccess: () => void;
  handleCancel: () => void;
  textCancelBtn?: string;
}

const SimCardNotification: React.FC<SimCardNotificationProps> = ({
  title,
  isModalOpen,
  textSuccessBtn,
  textCancelBtn = 'No, Thanks',
  formik,
  simCardRequest,
  handleSuccess,
  handleCancel,
}) => {
  const simCapValues = useAppSelector(getSIMCapValueDictSelector);
  const simCapValueDesc = simCapValues.find(
    (simCap) => simCap.codeNum === formik.values.reqCapValue
  )?.codeDesc;

  const customButtons = useMemo(() => {
    return [
      <MButton key="back" type="tertiary" onClick={handleCancel}>
        {textCancelBtn}
      </MButton>,
      <MButton key="submit" type="primary" onClick={handleSuccess}>
        {textSuccessBtn}
      </MButton>,
    ];
  }, [textCancelBtn, textSuccessBtn, handleSuccess, handleCancel]);

  return (
    <Modal
      open={isModalOpen}
      onOk={handleSuccess}
      onCancel={handleCancel}
      className={styles.modal}
      footer={customButtons}
      closeIcon={false}
    >
      <Flex vertical>
        <Flex className={styles.titleSection}>
          <Typography.Text className={styles.title}>{title}</Typography.Text>
        </Flex>
        <div className={styles.fieldsSection}>
          {simCardRequest === 'Input' && (
            <Flex vertical>
              <Typography.Text>Mobile Number:</Typography.Text>
              <MInput
                name="mobileNumber"
                onChange={(input) => {
                  formik.setFieldValue('mobileNumber', input.target.value);
                }}
                placeholder="Type Mobile Number"
              />
            </Flex>
          )}

          {simCardRequest === 'Dropdown' && (
            <Flex vertical>
              <Typography.Text>SIM Card Credit Limit:</Typography.Text>
              <MSelect
                options={transformDictToOptionsNum(simCapValues)}
                onChange={(selectValue) => {
                  formik.setFieldValue('reqCapValue', selectValue);
                }}
                value={simCapValueDesc}
                placeholder="Choose SIM Card Credit Limit"
              />
            </Flex>
          )}
        </div>
      </Flex>
    </Modal>
  );
};

export default memo(SimCardNotification);
